import axios from 'axios';
import { API_URL } from './constants';
import useAuthStore from '../store/authStore';

// Create an Axios instance with default config.
// Auth is a server-side HttpOnly session cookie; JS never sees a credential.
const api = axios.create({
  baseURL: `${API_URL}/v1`,
  headers: {
    'Content-Type': 'application/json',
    // CSRF guard: the backend requires this on session-authenticated writes
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
  timeout: 30000,
});

// Response interceptor: handle 401 globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect to login when auth is disabled on the server
      if (useAuthStore.getState().authDisabled) {
        return Promise.reject(error);
      }
      // Redirect to login if not already there. The auth probe itself
      // (/auth/me, /auth/login) must not trigger a redirect loop.
      const url = error.config?.url || '';
      const isAuthProbe = url.startsWith('/auth/');
      if (!isAuthProbe && window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
